import { FC, ReactNode } from 'react';
import { cx } from '@/utils/cx';

export type HeadingGroupContainerLayoutProps = {
  children: ReactNode;
  className?: string;
};

export const HeadingGroupContainerLayout: FC<
  HeadingGroupContainerLayoutProps
> = ({ children, className }) => (
  <>
    <div
      className={cx(
        'mb-8 flex flex-row items-center justify-between border-b border-gray-300 py-6',
        className,
      )}
    >
      {children}
    </div>
  </>
);
